import React from "react";
import { Form, Input } from "antd";
import type { Rule } from "antd/es/form";
import { InternationalPhoneInput } from "../../../shared/components/InternationalPhoneInput";
import {
  getInternationalPhoneFormRules,
  normalizeInternationalPhoneInput,
} from "../../../shared/utils/international-phone.util";

type AccountPhoneFormItemProps = {
  label: React.ReactNode;
  requiresInternationalFormat: boolean;
  translate: (key: string, defaultValue?: string) => string;
};

export const AccountPhoneFormItem: React.FC<AccountPhoneFormItemProps> = ({
  label,
  requiresInternationalFormat,
  translate,
}) => {
  const internationalRules = getInternationalPhoneFormRules(
    translate,
  ) as Rule[];

  return (
    <Form.Item
      label={label}
      name={["phone"]}
      rules={requiresInternationalFormat ? internationalRules : undefined}
      getValueFromEvent={
        requiresInternationalFormat
          ? (event: React.ChangeEvent<HTMLInputElement>) =>
              normalizeInternationalPhoneInput(event.target.value)
          : undefined
      }
      extra={
        requiresInternationalFormat
          ? translate(
              "accounts.hints.internationalPhoneQonto",
              "Format international requis pour Qonto (ex. +33612345678)",
            )
          : undefined
      }
    >
      {requiresInternationalFormat ? (
        <InternationalPhoneInput />
      ) : (
        <Input />
      )}
    </Form.Item>
  );
};
